import React from 'react';

const PaymentContext = React.createContext();
const SpreeContext = React.createContext();

export { PaymentContext, SpreeContext };
